import { render } from "./VideoSection.vue?vue&type=template&id=a1593224"
import script from "./VideoSection.vue?vue&type=script&lang=js"
export * from "./VideoSection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/florianroscher/Sites/simtschuk-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__